// extracted by mini-css-extract-plugin
export default {"contentWrapper":"CreateProjectMobile_contentWrapper__PRnUk","listWrapper":"CreateProjectMobile_listWrapper__qeZvw","listItem":"CreateProjectMobile_listItem__WRRf+"};